/* eslint-disable indent */

import {
  Flex,
  Heading,
  // Image
} from '@chakra-ui/react'
// import LOGO_IMPACTO from 'assets/images/brands/impacto/variant_1.svg'
import {
  ActivitiesModuleBrand,
  AppCitizenModuleBrand,
  AttendanceModuleBrand,
  CitizenPortalModuleBrand,
  CitizenProfileModuleBrand,
  DataIntegratorModuleBrand,
  DigitalArchiveModuleBrand,
  GeoModuleBrand,
  InstitutionalManagementModuleBrand,
  InventoryModuleBrand,
  MessengerModuleBrand,
  ProcessesAndDocumentsModuleBrand,
  RegulationModuleBrand,
  SchedulesModuleBrand,
  ServicesLetterModuleBrand,
  UnifiedLoginModuleBrand,
  VulnerabilityAlertsModuleBrand,
  ObservatoryModuleBrand,
} from 'components/media'

import { ACTIVITIES_MODULE } from 'Activities/constants/variables/module'
import { APP_CITIZEN_MODULE } from 'AppCitizen/constants/variables/module'
import { ATTENDANCES_MODULE } from 'Attendances/constants/variables/module'
import { CITIZEN_PORTAL_MODULE } from 'CitizenPortal/constants/variables/module'
import { CITIZEN_PROFILE_MODULE } from 'CitizenProfile/constants/variables/module'
import { DATA_INTEGRATOR_MODULE } from 'DataIntegrator/constants/variables/module'
import { DIGITAL_ARCHIVE_MODULE } from 'DigitalArchive/constants/variables/module'
import { GEO_MODULE } from 'Geo/constants/variables/module'
import { INSTITUTIONAL_MANAGEMENT_MODULE } from 'InstitutionalManagement/constants/variables/module'
import { INVENTORY_MODULE } from 'Inventory/constants/variables/module'
import { MESSENGER_MODULE } from 'Messenger/constants/variables/module'
import { REGULATION_MODULE } from 'Regulation/constants/variables/module'
import { SCHEDULES_MODULE } from 'Schedules/constants/variables/module'
import { SERVICES_LETTER_MODULE } from 'ServicesLetter/constants/variables/module'
import { UNIFIED_LOGIN_MODULE } from 'UnifiedLogin/constants/variables/module'
import { ALERTS_OF_VULNERABILITY_MODULE } from 'AlertsOfVulnerability/constants/variables/module'
import { OBSERVATORY_MODULE } from 'Observatory/constants/variables/module'

export default function ModuleBrandInFilter({ module }: { module: string }) {
  switch (module.toUpperCase()) {
    case 'ACTIVITIES':
      return (
        <Flex alignItems="center" gap={1}>
          <ActivitiesModuleBrand size={6} />
          <Heading fontSize="sm">{ACTIVITIES_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )
    case 'APP_CITIZEN':
      return (
        <Flex alignItems="center" gap={1}>
          <AppCitizenModuleBrand size={6} />
          <Heading fontSize="sm">{APP_CITIZEN_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'ATTENDANCES':
      return (
        <Flex alignItems="center" gap={1}>
          <AttendanceModuleBrand size={6} />
          <Heading fontSize="sm">{ATTENDANCES_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'CITIZEN_PORTAL':
      return (
        <Flex alignItems="center" gap={1}>
          <CitizenPortalModuleBrand size={6} />
          <Heading fontSize="sm">{CITIZEN_PORTAL_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'CITIZEN_PROFILE':
      return (
        <Flex alignItems="center" gap={1}>
          <CitizenProfileModuleBrand size={6} />
          <Heading fontSize="sm">{CITIZEN_PROFILE_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'DATA_INTEGRATOR':
      return (
        <Flex alignItems="center" gap={1}>
          <DataIntegratorModuleBrand size={6} />
          <Heading fontSize="sm">{DATA_INTEGRATOR_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'DIGITAL_ARCHIVE':
      return (
        <Flex alignItems="center" gap={1}>
          <DigitalArchiveModuleBrand size={6} />
          <Heading fontSize="sm">{DIGITAL_ARCHIVE_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'GEO':
      return (
        <Flex alignItems="center" gap={1}>
          <GeoModuleBrand size={6} />
          <Heading fontSize="sm">{GEO_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'INSTITUTIONAL_MANAGEMENT':
      return (
        <Flex alignItems="center" gap={1}>
          <InstitutionalManagementModuleBrand size={6} />
          <Heading fontSize="sm">{INSTITUTIONAL_MANAGEMENT_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'INVENTORY':
      return (
        <Flex alignItems="center" gap={1}>
          <InventoryModuleBrand size={6} />
          <Heading fontSize="sm">{INVENTORY_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'MESSENGER':
      return (
        <Flex alignItems="center" gap={1}>
          <MessengerModuleBrand size={6} />
          <Heading fontSize="sm">{MESSENGER_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'OBSERVATORY':
      return (
        <Flex alignItems="center" gap={1}>
          <ObservatoryModuleBrand size={6} />
          <Heading fontSize="sm">{OBSERVATORY_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'PROCESSES_AND_DOCUMENTS':
      return (
        <Flex alignItems="center" gap={1}>
          <ProcessesAndDocumentsModuleBrand size={6} />
          {/* <Heading fontSize="sm">{PROCESSES_AND_DOCUMENTS_MODULE.NAME_PTBR}</Heading> */}
        </Flex>
      )

    case 'REGULATION':
      return (
        <Flex alignItems="center" gap={1}>
          <RegulationModuleBrand size={6} />
          <Heading fontSize="sm">{REGULATION_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'SCHEDULES':
      return (
        <Flex alignItems="center" gap={1}>
          <SchedulesModuleBrand size={6} />
          <Heading fontSize="sm">{SCHEDULES_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'SERVICES_LETTER':
      return (
        <Flex alignItems="center" gap={1}>
          <ServicesLetterModuleBrand size={6} />
          <Heading fontSize="sm">{SERVICES_LETTER_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'UNIFIED_LOGIN':
      return (
        <Flex alignItems="center" gap={1}>
          <UnifiedLoginModuleBrand size={6} />
          <Heading fontSize="sm">{UNIFIED_LOGIN_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'VULNERABILITY_ALERTS':
      return (
        <Flex alignItems="center" gap={1}>
          <VulnerabilityAlertsModuleBrand size={6} />
          <Heading fontSize="sm">{ALERTS_OF_VULNERABILITY_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'GENERAL':
      return (
        <Flex alignItems="center" gap={1}>
          {/* <Image src={LOGO_IMPACTO.src} w="auto" h="30px" alt="Logo da Impacto" /> */}
          <Heading fontSize="sm">Geral</Heading>
        </Flex>
      )

    default:
      return <></>
  }
}
